import React from "react";
import Signup from "../flexport-page-comp/Auth/Signup";

const SignUp = () => <Signup />;

SignUp.layout = "L2";
export default SignUp;
